


















import { Component, Mixins } from 'vue-mixin-decorator';
import { Prop } from 'vue-property-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
@Component
export default class Dialog extends Mixins<SlotMixin>(SlotMixin) {
  @Prop()
  private dialog!: boolean;
}
